module.exports = __webpack_public_path__ + "img/Calendar.3080fa22.gif";